module.exports = __webpack_public_path__ + "static/arrow-a2e5baded4fb04577ee764de431d0082.png";